/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AssessmentQuestion from './assessment-question';
import AssessmentQuestionDetail from './assessment-question-detail';
import AssessmentQuestionUpdate from './assessment-question-update';
import AssessmentQuestionDeleteDialog from './assessment-question-delete-dialog';

const AssessmentQuestionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<AssessmentQuestion />} />
    <Route path="new" element={<AssessmentQuestionUpdate />} />
    <Route path=":id">
      <Route index element={<AssessmentQuestionDetail />} />
      <Route path="edit" element={<AssessmentQuestionUpdate />} />
      <Route path="delete" element={<AssessmentQuestionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AssessmentQuestionRoutes;
